/**
 * Indian market utility functions - INR formatting, market cap in Cr/Lakh, market hours.
 */

export const formatINR = (value, decimals = 2) => {
  if (value == null || isNaN(value)) return '—';
  const abs = Math.abs(value);
  const formatted = abs.toLocaleString('en-IN', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
  return `${value < 0 ? '-' : ''}₹${formatted}`;
};

export const formatMarketCap = (crores) => {
  if (crores == null || isNaN(crores)) return '—';
  if (crores >= 100000) {
    return `₹${(crores / 100000).toFixed(2)} L Cr`;
  }
  if (crores >= 1000) {
    return `₹${(crores / 1000).toFixed(2)} K Cr`;
  }
  return `₹${crores.toFixed(2)} Cr`;
};

export const formatVolume = (volume) => {
  if (volume == null || isNaN(volume)) return '—';
  if (volume >= 10000000) return `${(volume / 10000000).toFixed(2)} Cr`;
  if (volume >= 100000) return `${(volume / 100000).toFixed(2)} L`;
  if (volume >= 1000) return `${(volume / 1000).toFixed(2)} K`;
  return `${volume}`;
};

export const formatPercent = (value) => {
  if (value == null || isNaN(value)) return '—';
  const sign = value >= 0 ? '+' : '';
  return `${sign}${value.toFixed(2)}%`;
};

/**
 * Check if NSE/BSE market is currently open (9:15 AM - 3:30 PM IST, Mon-Fri)
 */
export const getMarketStatus = () => {
  const now = new Date();
  // Convert to IST (UTC+5:30)
  const istOffset = 5.5 * 60 * 60 * 1000;
  const utcTime = now.getTime() + now.getTimezoneOffset() * 60 * 1000;
  const istTime = new Date(utcTime + istOffset);

  const day = istTime.getDay(); // 0 = Sun, 6 = Sat
  const hours = istTime.getHours();
  const minutes = istTime.getMinutes();
  const totalMinutes = hours * 60 + minutes;

  const marketOpen = 9 * 60 + 15;  // 9:15 AM
  const marketClose = 15 * 60 + 30; // 3:30 PM
  const preMarketOpen = 9 * 60;     // 9:00 AM

  if (day === 0 || day === 6) {
    return { status: 'closed', label: 'Weekend', color: '#64748B' };
  }
  if (totalMinutes >= preMarketOpen && totalMinutes < marketOpen) {
    return { status: 'pre-market', label: 'Pre-Open', color: '#FBBF24' };
  }
  if (totalMinutes >= marketOpen && totalMinutes <= marketClose) {
    return { status: 'open', label: 'Live', color: '#00FF66' };
  }
  return { status: 'closed', label: 'Closed', color: '#64748B' };
};
